import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import Gallery from "../screens/users/Gallery";
import Blogs from "../screens/users/Blogs";
import Projects from "../screens/users/Projects";
import Services from "../screens/users/Services";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/projects",
    component: <Projects />,
  },
  {
    path: "/blogs",
    component: <Blogs />,
  },
  {
    path: "/gallery",
    component: <Gallery />,
  },
  {
    path: "/services/:categoryId",
    component: <Services />,
  },
];
